module.exports = "https://static.zego.com/_next/static/images/hero-ireland-taxi-landing-79fd8b4222a83bc1cee3fc111cbbbd76.jpg";